import getters from './getters'
import actions from './actions'
import mutations from './mutations'
import Custom from './custom'

/**
 * This store will be used for all modules of this component
 */
const state = {
  commonObj: {
    hasDropdownLoaded: false,
    serviceTypeList: [],
    serviceNameList: [],
    manualCategoryList: [],
    manualSubCategoryList: [],
    servicePointList: [],
    genderList: Custom.genderList
  }
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
